import { http } from '@/plugins/http'
import { normalize, schema } from 'normalizr'
import {
  RECEIVE_SCS,
  RECEIVING_SCS,
  RECEIVE_SC_METADATA,
  SAVING_SC,
  UPDATING_SC,
  DELETE_SC,
  DELETING_SC,
  INCREMENT_SC_COUNT,
  CLEAR_SC_STATE,
  RESET_SC_META,
  CLEAR_STATE
} from '../mutationTypes'
import { checkStatus, getHeaders, parseJSON, buildUrlWithQuery } from '@/utils/api'
import { getBySearchCriteria } from '@/utils/helpers/GetterHelpers/CommonGetterFunctions'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const sourcecodeSchema = new schema.Entity('sourcecodes')
const sourcecodeListSchema = new schema.Array(sourcecodeSchema)

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  next: null,
  previous: null,
  currentPage: 1,
  saving: false,
  receiving: false,
  updating: null,
  deleting: false
}

const actions = {
  fetchSourcecodesWithQuery (store, query) {
    const instanceUrl = this.getters.getActiveInstance.url
    const headers = getHeaders(this.getters.getToken)
    this.commit(RECEIVING_SCS, true)
    return http.get(buildUrlWithQuery('sourcecodes', query, instanceUrl), { headers })
      .then(checkStatus)
      .then(parseJSON)
      .then(r => {
        this.commit(RECEIVING_SCS, false)
        this.commit(RESET_SC_META)
        if (r.hasOwnProperty('results')) {
          const { results, next, previous, count } = r
          const { entities, result } = normalize(results, sourcecodeListSchema)
          this.commit(RECEIVE_SCS, { data: entities.sourcecodes })
          this.commit(RECEIVE_SC_METADATA, { next, previous, count, result: result.length })
          return { query, count, entities }
        }
      })
      .catch(e => {
        console.log(e)
        this.commit(RECEIVING_SCS, false)
        return e
      })
  },
  clearSourcecodeState () {
    return this.commit(CLEAR_SC_STATE)
  }
}

const getters = {
  getSourcecodes: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllSourcecodes: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getSourcecodeById: (state) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getSourcecodesBySearchCriteria: (state) => (query) => {
    return getBySearchCriteria(state.data, query)
  },
  getSourcecodeMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getSourcecodeFetchStatus: (state) => {
    return state.receiving
  },
  getSourcecodeSaveStatus: (state) => {
    return state.saving
  },
  getSourcecodeUpdateStatus: (state) => {
    return state.updating
  },
  getSourcecodeDeleteStatus: (state) => {
    return state.deleting
  },
  getDcSourceCode: state => Object.values(state.cache).find(sc => sc.code === 'DC') || {}
}

const mutations = {
  [RECEIVE_SCS] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_SCS] (state, payload) {
    state.receiving = payload
  },
  [SAVING_SC] (state, payload) {
    state.saving = payload
  },
  [UPDATING_SC] (state, payload) {
    state.updating = payload
  },
  [DELETE_SC] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_SC] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_SC_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_SC_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_SC_STATE] (state) {
    clearLocalState(state)
  },
  [RESET_SC_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
